'use strict';

require('../../style/index.less');

require('./index.less');

require('../../button/style');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/modal/style/index.js
// module id = 36
// module chunks = 0